import { loadModule } from "features/shared/helpers/modules";
import {
  BindFieldFunction,
  FormFields,
} from "features/shared/forms/hooks/useForm";
import { produce } from "immer";
import _ from "lodash";

const phoneInputConfig = loadModule<any>("forms/phoneInputConfig.json");

export interface PhoneInputConfig {
  prefix: string;
  regex: string;
}

export const loadPhoneInputConfiguration = (): PhoneInputConfig[] => {
  const configurations: PhoneInputConfig[] = phoneInputConfig;

  if (configurations?.length < 1) {
    throw new Error("Cannot load configuration from 'phoneInputConfig.json'");
  }

  return configurations;
};

export const getPhoneInputPrefixtDefault = (): string => {
  return loadPhoneInputConfiguration()[0].prefix;
};

export const assignPhoneInputPrefixDefault = (
  values: FormFields,
  inputPrefixName: string
): FormFields => {
  return produce(values, (valuesDraft) => {
    const value = _.get(values, inputPrefixName);
    if (!value) {
      const defaultPrefix = getPhoneInputPrefixtDefault();
      _.set(valuesDraft, inputPrefixName, defaultPrefix);
    }
  });
};

export const bindMobilePrefix = (
  bindField: BindFieldFunction,
  inputName: string = "mobilePrefix"
) => {
  const { onChange, value, name } = bindField<string>(inputName);

  return {
    onSelectChange: onChange,
    selectName: name,
    selectValue: value,
  };
};
